import { SVGProps } from 'react'

import { wrapIllustration } from '../wrap-illustration'

function SvgDocFlatDecision(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={160}
      height={160}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M85.928 100.205c6.344 0 11.488-5.143 11.488-11.488h-57.44c0 6.345-5.143 11.488-11.488 11.488h57.44Z"
        fill="#E2E8F0"
      />
      <path
        d="M28.488 100.205C22.143 100.205 17 95.062 17 88.717V19.79h57.44v68.927c0 6.345 5.143 11.488 11.488 11.488h-57.44Z"
        fill="#F1F5F9"
      />
      <path
        d="M73.64 88.717c0 6.787 5.502 12.288 12.288 12.288a.8.8 0 0 0 0-1.6c-5.903 0-10.688-4.785-10.688-10.688a.8.8 0 0 0-1.6 0Z"
        fill="#0F172A"
      />
      <path
        d="M65.824 78.344a.8.8 0 0 1 0 1.6H25.616a.8.8 0 0 1 0-1.6h40.208Zm0-5.744a.8.8 0 1 1 0 1.6H25.616a.8.8 0 1 1 0-1.6h40.208Zm0-5.744a.8.8 0 0 1 0 1.6H25.616a.8.8 0 1 1 0-1.6h40.208Zm0-5.744a.8.8 0 0 1 0 1.6H25.616a.8.8 0 1 1 0-1.6h40.208Zm-11.488-5.744a.8.8 0 0 1 0 1.6h-28.72a.8.8 0 0 1 0-1.6h28.72Zm-6.701-5.744a.8.8 0 0 1 0 1.6H25.616a.8.8 0 0 1 0-1.6h22.019Zm-3.83-5.744a.8.8 0 0 1 0 1.6H25.616a.8.8 0 0 1 0-1.6h18.19Zm1.914-5.744a.8.8 0 1 1 0 1.6H25.616a.8.8 0 1 1 0-1.6h20.103Zm6.703-5.744a.8.8 0 0 1 0 1.6H25.616a.8.8 0 1 1 0-1.6h26.806Z"
        fill="#B3C0D0"
      />
      <path d="m80.213 46.653-4.763 4.77 9.307 7.575 3.038-3.032-7.582-9.313Z" fill="#007A5F" />
      <path
        d="m69.484 24.935-15.75 15.751 12.368 12.37 15.751-15.752-12.369-12.37Z"
        fill="#00664F"
      />
      <path d="M82.024 48.875v7.907l-6.58-5.36 4.769-4.77 1.81 2.223Z" fill="#007A5F" />
      <path d="M82.024 48.875v7.907l-6.58-5.36 4.769-4.77 1.81 2.223Z" fill="#00664F" />
      <path
        d="M103.987 75.19a3.705 3.705 0 0 0-.199-5.42L87.795 55.96l-3.038 3.038 13.81 15.993a3.705 3.705 0 0 0 5.42.199ZM70.739 50.885l8.94-8.94.722.722a3.29 3.29 0 0 1 0 4.653l-4.287 4.287a3.29 3.29 0 0 1-4.653 0l-.722-.722Z"
        fill="#007A5F"
      />
      <path
        d="M65.353 26.003 54.8 36.557 70.354 52.11l10.553-10.554-15.553-15.554ZM49.698 40.395l-1.145 1.144a2.653 2.653 0 0 0 0 3.753l12.853 12.852a2.653 2.653 0 0 0 3.752 0l1.145-1.145a2.653 2.653 0 0 0 0-3.752L53.45 40.395a2.653 2.653 0 0 0-3.753 0ZM70.342 19.751l-1.145 1.145a2.653 2.653 0 0 0 0 3.752l12.852 12.853a2.653 2.653 0 0 0 3.753 0l1.144-1.145a2.653 2.653 0 0 0 0-3.753L74.094 19.751a2.653 2.653 0 0 0-3.752 0Z"
        fill="#78B441"
      />
      <path
        d="M87.635 54.995a.8.8 0 0 1 1.13 1.133l-3.847 3.84a.8.8 0 0 1-1.131-1.132l3.847-3.841ZM54.652 36.409a.8.8 0 0 1 1.131 0l14.72 14.72a.8.8 0 1 1-1.131 1.13l-14.72-14.72a.8.8 0 0 1 0-1.13ZM65.206 25.855a.8.8 0 0 1 1.131 0l14.72 14.72a.8.8 0 1 1-1.131 1.13l-14.72-14.72a.8.8 0 0 1 0-1.13Z"
        fill="#0F172A"
      />
    </svg>
  )
}
export default wrapIllustration(SvgDocFlatDecision)
